import React from 'react'
import classNames from 'classnames/bind'
import HeatMap from '@uiw/react-heat-map'
import type { UserProfile, ActivityHeatmapEntry } from '../../types'
import styles from '../../UserProfile.module.scss'

const cx = classNames.bind(styles)

function initials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map(w => w[0]?.toUpperCase() ?? '')
    .join('')
}

interface OverviewTabProps {
  user: UserProfile
  joinedDate: string
  activityHeatmap: ActivityHeatmapEntry[]
}

export default function OverviewTab({ user, joinedDate, activityHeatmap }: OverviewTabProps) {
  const endDate = new Date()
  const startDate = new Date()
  startDate.setFullYear(startDate.getFullYear() - 1)

  const heatmapValue = activityHeatmap.map(e => ({ date: e.date.replace(/-/g, '/'), count: e.count }))

  return (
    <div>
      <div className={cx('heatmapSection')}>
        <div className={cx('heatmapTitle')}>Activity — past year</div>
        <div className={cx('heatmapWrap')}>
          <HeatMap
            value={heatmapValue}
            startDate={startDate}
            endDate={endDate}
            width="100%"
            style={{ color: 'var(--t-muted)' }}
            rectSize={12}
            space={3}
            rectProps={{ rx: 2 }}
            panelColors={{
              0: 'var(--heatmap-empty)',
              1: 'var(--heatmap-l1)',
              3: 'var(--heatmap-l2)',
              6: 'var(--heatmap-l3)',
              10: 'var(--heatmap-l4)',
            }}
          />
        </div>
      </div>

      <div className={cx('activityItem')}>
        <div className={cx('activityAvatar')} aria-hidden="true">
          {initials(user.name)}
        </div>
        <div className={cx('activityBody')}>
          <div className={cx('activityMeta')}>
            <span className={cx('activityName')}>{user.name}</span>
            <span className={cx('activityTime')}>{joinedDate}</span>
          </div>
          <p className={cx('activityText')}>Account created.</p>
        </div>
      </div>
    </div>
  )
}
